import '@/components/reusable/RNotification';
const stylesheet = new CSSStyleSheet();
stylesheet.replaceSync(`
  .notification {
    z-index: 3000;
    position: fixed;
    left: 10%;
    right: 10%;
  }
`);
document.adoptedStyleSheets.push(stylesheet);
class NotificationController {
    /** @description Gap between notifications in pixels */
    gap = 20;
    show({ content, duration = 3000, type }) {
        this.#createNotificationElement({ content, duration, type });
        this.#numberOfActiveNotifications += 1;
    }
    #numberOfActiveNotifications = 0;
    #calculateNewOffset(notificationNumber) {
        let sum = 0;
        const $notifications = document.body.querySelectorAll('.notification');
        for (let i = 0; i < notificationNumber - 1; i++) {
            sum += $notifications[i].getBoundingClientRect().height;
        }
        return notificationNumber * this.gap + sum;
    }
    #createNotificationElement({ content, duration, type }) {
        const $notification = document.createElement('r-notification');
        $notification.setAttribute('duration', duration);
        $notification.setAttribute('type', type);
        $notification.classList.add('notification');
        $notification.insertAdjacentHTML('afterbegin', content);
        $notification.style.top = `${this.#calculateNewOffset(this.#numberOfActiveNotifications + 1)}px`;
        $notification.addEventListener('expired', this.#onTimerExpiration.bind(this));
        document.body.append($notification);
    }
    #onTimerExpiration(e) {
        e.target.remove();
        this.#numberOfActiveNotifications -= 1;
        requestAnimationFrame(() => this.#repositionNotifications());
    }
    #repositionNotifications() {
        document.body.querySelectorAll('.notification').forEach(($el, index) => {
            $el.style.top = `${this.#calculateNewOffset(index + 1)}px`;
        });
    }
}
export const notificationController = new NotificationController();
